module.exports = __webpack_public_path__ + "static/man-ol-7c8df9a72ef9872f65f63ce83516009c.jpg";